var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h2',[_vm._v("Ping Test")]),_c('v-btn',{on:{"click":_vm.testBackend}},[_vm._v("Test Backend")]),(_vm.responseMessage)?_c('div',[_vm._v(_vm._s(_vm.responseMessage))]):_vm._e(),(_vm.errorMessage)?_c('div',{staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.errorMessage))]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }